import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';
import BaseDialog from '../BaseDialog';

const NameSetupDialog = ({
  isVisible,
  initialName = '',
  loading = false,
  message = '',
  onSave,
  onLater,
}) => {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isVisible) {
      setName(initialName || '');
    }
  }, [initialName, isVisible]);

  const trimmedName = name.trim();
  const canSave = trimmedName.length > 0 && !loading;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!canSave) {
      return;
    }
    onSave?.(trimmedName);
  };

  return (
    <BaseDialog isVisible={isVisible} onClose={onLater} clickOutsideToClose={false} maxWidth="min(92vw, 400px)" padding="18px">
      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={2.25} sx={{ width: 360, maxWidth: '100%' }}>
          <Box>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 800, lineHeight: 1.35 }}>
              表示名を設定しますか？
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.75, color: '#555', lineHeight: 1.7 }}>
              チャットや結果画面に表示される名前です。その他のユーザー情報はマイページから設定できます。
            </Typography>
          </Box>

          <TextField
            autoFocus
            label="表示名"
            value={name}
            onChange={(event) => setName(event.target.value)}
            inputProps={{ maxLength: 10 }}
            disabled={loading}
            fullWidth
          />

          {message && <Alert severity="error">{message}</Alert>}

          <Stack direction="row" spacing={1.25} justifyContent="flex-end">
            <Button variant="outlined" onClick={onLater} disabled={loading}>
              あとで
            </Button>
            <Button type="submit" variant="contained" disabled={!canSave}>
              {loading ? '保存中...' : '保存'}
            </Button>
          </Stack>
        </Stack>
      </Box>
    </BaseDialog>
  );
};

export default NameSetupDialog;
